import { Drawer, styled } from '@mui/material';

export const DrawerStyled = styled(Drawer)(() => ({
  '& .MuiPaper-root': {
    padding: '24px 16px 40px',
    borderRadius: '16px 16px 0px 0px',
    zIndex: 5000
  },

  '.close_icon_button': {
    position: 'absolute',
    top: 16,
    right: 8,
    zIndex: 1,
  },
}));
